import * as React from "react";

import { Step } from "../TourTypes";

export const colgroupButtonTourStep: Step = {
    id: "candyform_colgroupbutton",
    header: "Компактная таблица",
    content: (
        <div>
            {"Нажимайте на столбцы-кнопки — они будут"}
            <br />
            {"скрываться и раскрываться."}
            <p>
                {"В этих столбцах поля, которые редко нужны."}
                <br />
                {"Если их скрыть, получится компактная таблица,"}
                <br />
                {"с которой легко работать."}
            </p>
        </div>
    ),
    positions: ["left top", "top left", "top center", "top right", "bottom left", "bottom center", "bottom right"],
    offset: 35,
};
